module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hrms13x-detail-tab3"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRPM81X4']['10']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-7 clearfix"
  }, [_c('div', {
    staticClass: "detail-header",
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRPM81X4']['20']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab3Table1,
      "data": _vm.data.table1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 clearfix"
  }, [_c('div', {
    staticClass: "detail-header",
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRPM81X4']['60']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab3Table2,
      "data": _vm.data.table2
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c5acc22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms13x/detailTab3.vue
// module id = 3547
// module chunks = 1